import React from 'react';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../CommonComponents/OPL/Text/Text';
import { AccordionButton } from '../../../CommonComponents/OPL/Accordion/AccordionButton/AccordionButton';
import { AccordionPanel } from '../../../CommonComponents/OPL/Accordion/AccordionPanel/AccordionPanel';

interface FilterAccordionProps {
  id: string;
  title: string;
  isExpanded: boolean;
  onToggle: () => void;
  zIndex: number;
  showTopBorder?: boolean;
  children: React.ReactNode;
}

export const FilterAccordion = ({
  id,
  title,
  isExpanded,
  onToggle,
  zIndex,
  showTopBorder = false,
  children,
}: FilterAccordionProps) => {
  const buttonId = `${id}-button`;
  const panelId = `${id}-panel`;

  return (
    <Box
      borderTop={showTopBorder ? '1px solid' : undefined}
      borderColor={showTopBorder ? 'neutral.200' : undefined}
    >
      <AccordionButton
        variant="embedded"
        id={buttonId}
        panelId={panelId}
        isActive={isExpanded}
        onClick={onToggle}
        css={`
          position: sticky;
          top: 0;
          z-index: ${zIndex};
        `}
        content={
          <Box py="12" width="100%">
            <Text variant="smallCaps">{title}</Text>
          </Box>
        }
      />
      <AccordionPanel id={panelId} buttonId={buttonId} isActive={isExpanded} variant="embedded">
        {children}
      </AccordionPanel>
    </Box>
  );
};
